export const theme = {
    colors: {
        primary: {
            default: "rgba(0, 127, 128, 1)",
            hover: "#00b2b3ff",
            active: "#00ccccff"
        },
        green: {
            default: "green",
            hover: "#00b300ff",
            active: "#00e600ff"
        },
        crimson: {
            default: "crimson",
            hover: "#eb284fff",
            active: "#ee4466ff"
        }
    },
    breakpoints: {
        mobile: 767
    }
}